import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_SECURITY_API_URL,
  realm: "LivingMap",
  clientId: "mms-client",
});

export default keycloak;
